export default {
  namespaced: true,

  state: {
    locale: null,
    propertyId: null,
    updatedAt: null
  },

  mutations: {
    setLocale(state, value) {
      state.locale = value
    },
    setPropertyId(state, value) {
      state.propertyId = value
    },
    setUpdatedAt(state, value) {
      state.updatedAt = value
    }
  }
}
